// extracted by mini-css-extract-plugin
export default {"backdrop":"Notice_backdrop__RtiXF","notice":"Notice_notice__Ow60U","message":"Notice_message__H2+Ed"};